"use client";
import { createContext } from "react";
//#region packages/@mantine/core/src/components/Menu/MenuRadioGroup/MenuRadioGroup.context.tsx
const MenuRadioGroupContext = createContext(null);
//#endregion
export { MenuRadioGroupContext };

//# sourceMappingURL=MenuRadioGroup.context.mjs.map